import { render } from "./PlanningDisabilityTravel.vue?vue&type=template&id=5720577e&scoped=true"
import script from "./PlanningDisabilityTravel.vue?vue&type=script&lang=js"
export * from "./PlanningDisabilityTravel.vue?vue&type=script&lang=js"

import "./PlanningDisabilityTravel.vue?vue&type=style&index=0&id=5720577e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5720577e"]])

export default __exports__